var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Shipping is taxable')},model:{value:(_vm.shipping_taxable),callback:function ($$v) {_vm.shipping_taxable=$$v},expression:"shipping_taxable"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }